import { watchAddInfoSalesCall } from './addInfoSalesCall';
import { watchAddSalesCall } from './addSalesCall';
import { watchDeleteSalesCall } from './deleteSalesCall';
import { watchFetchPagedSalesCalls } from './fetchPagedSalesCalls';
import { watchFetchSalesCalls } from './fetchSalesCalls';
import { watchFetchSalesCallsByDate } from './fetchSalesCallsByDate';
import { watchUpdateSalesCall } from './updateSalesCall';

export const salesCallSagas = [
  watchAddInfoSalesCall(),
  watchAddSalesCall(),
  watchDeleteSalesCall(),
  watchFetchPagedSalesCalls(),
  watchFetchSalesCalls(),
  watchFetchSalesCallsByDate(),
  watchUpdateSalesCall()
];
